//old
const BOBCAT_BASEHREF = 'http://bobcatcenter.localhost/i/';
export const BOBCAT_API = {
    'TYPE_DOCUMENT': 'http://bobcatcenter.localhost/i/document/getTypeDocument',
    'SAVE_SOCIETE': 'http://bobcatcenter.localhost/i/societe/saveSociete',
    'SAVE_DOC': 'http://bobcatcenter.localhost/i/document/saveDocument',
    'SAVE_SIGNATAIRE': 'http://bobcatcenter.localhost/i/document/saveSignataire',
    'UPDATE_SOCIETE': 'http://bobcatcenter.localhost/i/societe/updateSociete',
    'ALL_SOCIETE': 'http://bobcatcenter.localhost/i/societe/getAllSociete',
    'LOGIN': 'http://bobcatcenter.localhost/i/xtranet/auth',
    'LIST_DOCUMENT': 'http://bobcatcenter.localhost/i/document/getListDocument',
    'GAMMES_SITES': 'http://bobcatcenter.localhost/i/KStructureSite/getGammesSites',
    'SAVE_STRUCTURE': 'http://bobcatcenter.localhost/i/KStructureSite/saveStructureSite',
    'STRUCTURE_SITE': 'http://bobcatcenter.localhost/i/KStructureSite/getStructureSite',
    'LIST_MODULES': 'http://bobcatcenter.localhost/i/KModules/getListModules',
    'SAVE_MODULES': 'http://bobcatcenter.localhost/i/KModules/saveModules',
    'SAVED_MODULES': 'http://bobcatcenter.localhost/i/KModules/getModules',
    'LIST_INFOSTECHNQUES': 'http://bobcatcenter.localhost/i/KInfosTechniques/getInfosTechniques',
    'SAVE_INFOSTECHNQUES': 'http://bobcatcenter.localhost/i/KInfosTechniques/saveInfosTechniques',

    'DOCS': 'http://bobcatcenter.localhost/i/KontractorStructure/getStructure',
    'STEPS': 'http://bobcatcenter.localhost/i/KontractorStructure/getSteps',
    'STEP': 'http://bobcatcenter.localhost/i/KontractorStructure/getStep',
};

export const KONTRACTOR_API = {
    "login": "/login",
    "structure":
        {
            "getList": "/types",
            "get": "/type",
            "post": null,
            "delete": null
        },
    "steps":
        {
            "get": "/step",
            "post": null,
            "delete": null
        },
    "params":
        {
            "getList": "/params",
            "post": null,
            "delete": null
        },
    "widget":
        {
            "getList": "/widgets",
            "post": null,
            "delete": null
        },
    "Modules":
        {
            "getList": null,
            "get": null,
            "post": null,
            "delete": null
        },
    "Doc":
        {
            "getList": "",
            "get": "",
            "post": null,
            "delete": null
        },
    "Societe":
        {
            "getList": null,
            "get": null,
            "post": null,
            "delete": null
        },
    "InfoTech":
        {
            "getList": null,
            "get": null,
            "post": null,
            "delete": null
        },
    "baseHref": "https://api-kontractor.la-boite-immo.fr",
    "baseHrefApi": "https://api-kontractor.la-boite-immo.fr/api"
};



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/common/utils/api.bobcat.ts